export const API_URL = process.env.REACT_APP_BASE_URL;

export const API_ENDPOINTS = {
  API_URL: API_URL,
  INS_LOGIN: API_URL + "/admin/login/",
  INS_RESET_PASSWORD: API_URL + "/iap/password_reset/",
  GET_ALL_INSTITUTE: `${API_URL}/institute/list/institute/`, //get all users
  GET_INSTITUTE: `${API_URL}/institute/get_institute`, //get institute by email
  EMAIL_VERIFICATION: `${API_URL}/student/send_verification_email/`,
  STUDENT: `${API_URL}/student/`,

  MAINTAINANCE: API_URL + "/maintenance",
  STUDENT_EMAIL_VERIFICATION: `${API_URL}/student/resend_verification_email/`,
};
